import { UserRoleModal } from 'Containers/User/Models/UserModel/UserModel';

export const isCompanyAdmin = (roles: Array<UserRoleModal>) =>
  roles?.length > 0
    ? roles.some(({ name }: UserRoleModal) => {
        const role = name.toLocaleLowerCase();
        return role === 'company-admin' || role === 'super-admin';
      })
    : false;
